import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { AuthenticationService } from '@sb-tools/typescript/authentication/authentication.service';

@Injectable()
export class TrustpilotRedirectGuard implements CanActivate {
    constructor(
        private router: Router,
        private authenticationService: AuthenticationService,
    ) {}

    canActivate(route: ActivatedRouteSnapshot): boolean {
        const urlSearchParams = new URLSearchParams(route.queryParams);
        const community = this.authenticationService.community;
        const trustpilotToken = urlSearchParams.get('code');

        if (community) {
            if (trustpilotToken) {
                this.router.navigate([`/${community}/community/installation/trustpilot`], {
                    queryParams: { code: trustpilotToken },
                });
            } else {
                this.router.navigate([`/${community}/community/installation/trustpilot`]);
            }
        }

        return true;
    }
}
